(() => {
  const root = document.querySelector('[data-mervor-imported-landing]');
  if (!root) return;

  const descriptionImages = [...root.querySelectorAll('[data-imported-description] img')];
  descriptionImages.forEach((image, index) => {
    image.loading = index === 0 ? 'eager' : 'lazy';
    image.decoding = 'async';
    if (index === 0) image.fetchPriority = 'high';
  });

  const deadlineValue = root.dataset.offerDeadline;
  if (deadlineValue) {
    const deadline = new Date(deadlineValue).getTime();
    if (Number.isFinite(deadline)) {
      const fields = {
        hours: root.querySelector('[data-countdown-hours]'),
        minutes: root.querySelector('[data-countdown-minutes]'),
        seconds: root.querySelector('[data-countdown-seconds]')
      };

      let timer;
      const updateCountdown = () => {
        const remaining = Math.max(0, deadline - Date.now());
        const totalSeconds = Math.floor(remaining / 1000);
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        if (fields.hours) fields.hours.textContent = String(hours).padStart(2, '0');
        if (fields.minutes) fields.minutes.textContent = String(minutes).padStart(2, '0');
        if (fields.seconds) fields.seconds.textContent = String(seconds).padStart(2, '0');
        if (remaining === 0 && timer) window.clearInterval(timer);
      };

      updateCountdown();
      timer = window.setInterval(updateCountdown, 1000);
    }
  }

  const variantSelect = root.querySelector('[data-variant-select]');
  const variantPills = [...root.querySelectorAll('[data-mervor-variant-pill]')];
  const buyNowButton = root.querySelector('[data-mervor-buy-now]');

  const syncVariantPills = () => {
    if (!variantSelect) return;
    const selectedOption = variantSelect.options[variantSelect.selectedIndex];
    variantPills.forEach((pill) => {
      const selected = pill.dataset.variantId === variantSelect.value;
      pill.classList.toggle('is-selected', selected);
      pill.setAttribute('aria-pressed', String(selected));
    });
    if (buyNowButton) buyNowButton.disabled = selectedOption?.dataset.available !== 'true';
  };

  variantPills.forEach((pill) => {
    pill.addEventListener('click', () => {
      if (!variantSelect || pill.disabled) return;
      variantSelect.value = pill.dataset.variantId;
      variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
      syncVariantPills();
    });
  });

  variantSelect?.addEventListener('change', syncVariantPills);
  document.addEventListener('mervor:variant-change', syncVariantPills);
  syncVariantPills();

  buyNowButton?.addEventListener('click', async () => {
    const form = buyNowButton.closest('form[action*="/cart/add"]');
    if (!form || buyNowButton.disabled) return;

    const originalText = buyNowButton.textContent;
    buyNowButton.disabled = true;
    buyNowButton.setAttribute('aria-busy', 'true');
    buyNowButton.textContent = 'WIRD VORBEREITET …';

    try {
      const routeRoot = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${routeRoot}cart/add.js`, {
        credentials: 'same-origin',
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      if (!response.ok) {
        const payload = await response.json().catch(() => ({}));
        throw new Error(payload.description || 'Das Produkt konnte nicht hinzugefügt werden.');
      }
      window.location.assign(`${routeRoot}checkout`);
    } catch (error) {
      buyNowButton.textContent = error.message || 'BITTE ERNEUT VERSUCHEN';
      window.setTimeout(() => {
        buyNowButton.textContent = originalText;
        syncVariantPills();
      }, 2600);
    } finally {
      buyNowButton.removeAttribute('aria-busy');
      if (!buyNowButton.textContent.includes('erneut')) syncVariantPills();
    }
  });
})();
